import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/fila`

    return {
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        evade(id, params) {
            return repository.put(`${baseUrl}/${id}/evade`, params)
        },
        undoEvade(id, params) {
            return repository.put(`${baseUrl}/${id}/undo-evade`, params)
        },
        sendBack(id) {
            return repository.put(`${baseUrl}/${id}/send-back`)
        },
        destroy(id) {
            return repository.delete(`${baseUrl}/${id}`)
        },
        getAgendamentosRetroativos(queryParms) {
            return repository.get(`${baseUrl}/agendamento-retroativo?${urlUtil.serialize(queryParms)}`)
        },
        forward(id, params) {
            return repository.patch(`${baseUrl}/${id}/forward`, params)
        },
    }
}